// extracted by mini-css-extract-plugin
export default {"img-zoom-container":"img-zoom-container_LQsMiw8C","lens":"lens_dlyvPmE_","img-zoom-result":"img-zoom-result_N9RuLjia"};